export default "__VITE_ASSET__BNuG$H6o__"